module.exports = __webpack_public_path__ + "static/media/french-fries.87e3fac5.svg";